module.exports = __webpack_public_path__ + "assets/assets/images/icons/default-profile-picture.76e95bdf.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/default-profile-picture.svg
// module id = 278
// module chunks = 2